var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50016 7.33342H3.66683C2.74461 7.33342 1.9585 7.00842 1.3085 6.35842C0.658496 5.70842 0.333496 4.9223 0.333496 4.00008C0.333496 3.07786 0.658496 2.29175 1.3085 1.64175C1.9585 0.991748 2.74461 0.666748 3.66683 0.666748H6.50016V1.66675H3.66683C3.02238 1.66675 2.47238 1.89453 2.01683 2.35008C1.56127 2.80564 1.3335 3.35564 1.3335 4.00008C1.3335 4.64453 1.56127 5.19453 2.01683 5.65008C2.47238 6.10564 3.02238 6.33342 3.66683 6.33342H6.50016V7.33342ZM4.40016 4.50008V3.50008H9.56683V4.50008H4.40016ZM13.6668 4.00008H12.6668C12.6668 3.35564 12.4391 2.80564 11.9835 2.35008C11.5279 1.89453 10.9779 1.66675 10.3335 1.66675H7.50016V0.666748H10.3335C11.2557 0.666748 12.0418 0.991748 12.6918 1.64175C13.3418 2.29175 13.6668 3.07786 13.6668 4.00008ZM10.6502 9.33342V7.33342H8.65016V6.33342H10.6502V4.33341H11.6502V6.33342H13.6502V7.33342H11.6502V9.33342H10.6502Z",
    fill: "white",
    fillOpacity: 0.92
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectWallet);
export default __webpack_public_path__ + "static/media/connectWallet.2efbd375107567401d06f7cb45214031.svg";
export { ForwardRef as ReactComponent };